import React from 'react'
import { LuPlus } from 'react-icons/lu'
import { v4 as uuidv4 } from 'uuid'
import Tooltip from 'react-bootstrap/Tooltip'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import classNames from 'classnames'

import { FILE_CONTENT_TYPES } from 'bundles/Pilot/utils/files'
import { useAppDispatch, useTemporaryTooltip } from 'bundles/Pilot/hooks'
import { uploadFile } from './actions'
import { updateFileProgress } from './slice'

type Props = {
  threadKey?: string
  disabled?: boolean
}

function AttachFileButton({ threadKey, disabled = false }: Props) {
  const dispatch = useAppDispatch()
  const fileInputRef = React.useRef<HTMLInputElement>(null)
  const { show: showTooltip, trigger: showTooltipOnClick } = useTemporaryTooltip(1000)

  const attachFileButtonClassName = classNames('attach-file-button', {
    'attach-file-button--disabled': disabled,
  })

  const handleClick = () => {
    if (disabled) return
    showTooltipOnClick()
  }

  const handleFilesChanged = e => {
    if (disabled || !threadKey) return

    const files = e.target?.files
    if (!files) return

    for (const file of files) {
      const clientId = uuidv4()

      dispatch(
        uploadFile({
          attachment: file,
          clientId,
          threadKey,
          onProgress: (progress: number) => {
            dispatch(updateFileProgress({ clientId, progress }))
          },
        })
      )

      fileInputRef.current.value = null
    }
  }

  return (
    <>
      <input
        type='file'
        style={{ display: 'none' }}
        ref={fileInputRef}
        onChange={handleFilesChanged}
        accept={FILE_CONTENT_TYPES.join(',')}
        multiple={true}
        id='file-input'
        disabled={disabled}
      />
      <OverlayTrigger
        placement='top'
        overlay={<Tooltip id='tooltip-attach-file'>Add photos and files</Tooltip>}
        show={showTooltip || undefined}
        trigger={['hover', 'focus']}
      >
        <label
          htmlFor='file-input'
          className={attachFileButtonClassName}
          onClick={handleClick}
          aria-label='Attach images or PDF files'
        >
          <LuPlus size={32} className='attach-file-icon' />
        </label>
      </OverlayTrigger>
    </>
  )
}

export default AttachFileButton
